import { render, staticRenderFns } from "./CloudAttach.vue?vue&type=template&id=1aa16b7c&scoped=true&"
import script from "./CloudAttach.vue?vue&type=script&lang=js&"
export * from "./CloudAttach.vue?vue&type=script&lang=js&"
import style0 from "./CloudAttach.vue?vue&type=style&index=0&id=1aa16b7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa16b7c",
  null
  
)

export default component.exports